import { Col, Image, Row, Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AccountAPI } from 'api/account';
import SmallJumpBigLeap from 'assets/small_jump_big_leap.png';
import RocketlaneLogoSvg from 'assets/svgs/rocketlane_logo_full.svg';
import { TokenError, TokenErrorStatus } from 'components/organisms/token-error';
import { ProductiveHeading03 } from 'components/styles';
import { useQueryParams } from 'hooks/use-query-params';
import { getTokenMeta } from 'utils/token';
import { AccountSetupForm } from './form';

const StyledRow = styled(Row)`
  background-color: var(--gray-10);
  height: 100vh;
`;

const Left = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const LeftTop = styled.div`
  padding: var(--spacing-08) var(--spacing-10);
`;

const LeftBottom = styled.div`
  height: 50%;
  background-image: url(${SmallJumpBigLeap});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const Right = styled(Col)`
  background-color: var(--white-100);
`;

const FlexBox = styled.div`
  display: flex;
  justify-content: center;
  padding-top: var(--spacing-10);
`;

const Container = styled.div`
  width: 368px;
`;

const BaseHeading = styled.div`
  ${ProductiveHeading03};
  width: 80%;
`;

const PrimaryHeading = styled(BaseHeading)`
  font-weight: var(--font-weight-bold);
`;

const SecondaryHeading = BaseHeading;

export const AccountActivatePage: FC = () => {
  const params = useQueryParams();
  const token = params.get('token') ?? '';
  const { decoded, isExpired } = getTokenMeta(token);

  if (!decoded) {
    return <TokenError status={TokenErrorStatus.Invalid} />;
  }
  if (isExpired) {
    return (
      <TokenError
        email={decoded.emailId}
        status={TokenErrorStatus.Expired}
        resendEmail={() => AccountAPI.resendAccountActivation()}
      />
    );
  }

  return (
    <>
      <StyledRow gutter={0} wrap={false}>
        <Left flex="auto">
          <LeftTop>
            <Space direction="vertical" size={84}>
              <div>
                <Image
                  width={160}
                  src={RocketlaneLogoSvg}
                  alt="Rocketlane"
                  preview={false}
                />
              </div>
              <Space direction="vertical" size={16}>
                <PrimaryHeading>
                  <FormattedMessage id="account_setup.title" />
                </PrimaryHeading>
                <SecondaryHeading>
                  <FormattedMessage id="account_setup.message" />
                </SecondaryHeading>
              </Space>
            </Space>
          </LeftTop>
          <LeftBottom />
        </Left>
        <Right flex="600px">
          <FlexBox>
            <Container>
              <Space direction="vertical" size={24}>
                <div>
                  <FormattedMessage
                    id="account_setup.signing_up_as"
                    values={{
                      b: (chunks) => <b>{chunks}</b>,
                      emailId: decoded.emailId,
                    }}
                  />
                </div>
                <AccountSetupForm token={token} emailId={decoded.emailId} />
              </Space>
            </Container>
          </FlexBox>
        </Right>
      </StyledRow>
    </>
  );
};
